import { ComitatiService } from './../../../../../services/comitati/comitati.service';
import { Component, Inject, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PolicyService } from 'src/app/services/policy/policy.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-crea-comitati',
  templateUrl: './dialog-crea-comitati.component.html',
  styleUrls: ['./dialog-crea-comitati.component.scss'],
  standalone: false,
})
export class DialogCreaComitatiComponent implements AfterViewInit {
  public formComitati = new FormGroup({
    id: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),

    descrizione: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),

    guidaAllaScrittura: new FormControl<string>('', {
      nonNullable: true,
      validators: [],
    }),
    creatoDaContesto: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
    selected: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
    compilato: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
    figura: new FormControl<any>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    idAzienda: new FormControl<string>('', {
      nonNullable: true,
      validators: [],
    }),
  });

  constructor(
    public dialogRef: MatDialogRef<DialogCreaComitatiComponent>,
    private comitatiService: ComitatiService,
    private utilityService: UtilityService,
    private policyService: PolicyService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      comitati: any;
      idAzienda: string;
    },
  ) {}

  ngAfterViewInit(): void {
    if (this.data.idAzienda) {
      // è un comitato epr azienda, si nasconde il campo di "Guida alla scrittura" e si rende non obbligatorio
      this.formComitati
        .get('guidaAllaScrittura')
        ?.removeValidators([Validators.required, UtilityService.blankValidator]);
    } else {
      this.formComitati
        .get('guidaAllaScrittura')
        ?.addValidators([Validators.required, UtilityService.blankValidator]);
    }

    this.formComitati.get('guidaAllaScrittura')?.updateValueAndValidity();

    if (this.data?.comitati) {
      Object.keys(this.data.comitati).forEach((value, index, array) => {
        this.formComitati.get(value)?.setValue(this.data.comitati[value]);
      });
    }
  }

  public salva() {
    if (this.formComitati.valid) {
      const id = this.formComitati.get('id')?.value;

      if (this.data.idAzienda) {
        this.formComitati.get('idAzienda')?.setValue(this.data.idAzienda);
      }

      if (id) {
        return this.comitatiService.putComitati(id, this.formComitati.getRawValue()).subscribe({
          next: (result) => {
            this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
              duration: 2000,
              panelClass: ['success-snackbar'],
            });
            this.dialogRef.close(result);
          },
          error: (err: any) => {
            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: err.error.message,
              bottoni: [{ nome_btn: 'Chiudi' }],
            });
          },
        });
      } else {
        return this.comitatiService.postComitati(this.formComitati.getRawValue()).subscribe({
          next: (result) => {
            this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
              duration: 2000,
              panelClass: ['success-snackbar'],
            });
            this.dialogRef.close(result);
          },
          error: () => {
            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: 'Errore nel salvataggio ',
              bottoni: [{ nome_btn: 'Chiudi' }],
            });
          },
        });
      }
    } else {
      Object.values(this.formComitati.controls).forEach((control) => {
        control.markAsTouched();
      });
    }
    return null;
  }
}
